/**
 * Empty-state art for the clear flow.
 *
 * The shared empty state animates a Lottie whose palette is Blueticks blue and
 * yellow — the single loudest colour in the clear panel, and off-brand there.
 * A hue-rotate would drag the yellows to green, so this is a purpose-drawn
 * replacement instead, in the flow's own indigo/violet and reusing the logo's
 * bubble-and-clock motif.
 *
 * Inline SVG (no asset fetch) and decorative: aria-hidden, with the meaning
 * carried by the heading and body text beside it.
 */
export default function ClearEmptyIllustration() {
  return (
    <svg
      viewBox="0 0 240 180"
      width="100%"
      height="100%"
      style={{ maxWidth: 200, maxHeight: 150 }}
      role="presentation"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id="clear-empty-accent" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#6366F1" />
          <stop offset="1" stopColor="#8B5CF6" />
        </linearGradient>
      </defs>

      {/* halo */}
      <ellipse cx="120" cy="96" rx="82" ry="66" fill="#EEF2FF" />

      {/* back card — a scheduled item waiting in the list */}
      <rect x="52" y="52" width="118" height="34" rx="10" fill="#fff" stroke="#DDD8FA" strokeWidth="2" />
      <rect x="64" y="64" width="54" height="5" rx="2.5" fill="#C7D2FE" />
      <rect x="64" y="74" width="34" height="5" rx="2.5" fill="#E3E0FB" />

      {/* front card */}
      <rect x="70" y="92" width="118" height="38" rx="10" fill="#fff" stroke="#CFC8F7" strokeWidth="2" />
      <rect x="82" y="105" width="62" height="5" rx="2.5" fill="#C7D2FE" />
      <rect x="82" y="116" width="40" height="5" rx="2.5" fill="#E3E0FB" />

      {/* the brand mark: a bubble carrying a clock = a message with a time on it */}
      <g transform="translate(150 34)">
        <path
          d="M10 0h34a10 10 0 0 1 10 10v20a10 10 0 0 1-10 10H26L12 52V40h-2A10 10 0 0 1 0 30V10A10 10 0 0 1 10 0z"
          fill="url(#clear-empty-accent)"
        />
        <circle cx="27" cy="20" r="10" fill="none" stroke="#fff" strokeWidth="3" />
        <path d="M27 13.5V20l4.5 3.2" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </g>

      {/* sparkles */}
      <circle cx="46" cy="118" r="4" fill="#C4B5FD" />
      <circle cx="196" cy="118" r="5" fill="#DDD6FE" />
      <circle cx="62" cy="36" r="3" fill="#C7D2FE" />
    </svg>
  );
}
